export default function FeaturesSection() {
  const features = [
    {
      icon: 'ri-global-line',
      title: '全网平台聚合',
      description: '整合香蕉视频、红桃视频、91视频、蜜桃视频等主流在线视频平台入口，一个页面即可触达全网优质资源，告别多站切换的繁琐体验。',
    },
    {
      icon: 'ri-speed-up-line',
      title: '流畅不缓冲播放',
      description: '推荐的平台均经过实际播放测试，在不同网络环境下保持良好表现。采用智能码率适配技术，即便在移动网络下也能稳定高清播放。',
    },
    {
      icon: 'ri-shield-check-line',
      title: '安全可靠导航',
      description: '所有收录平台经过安全审查，无恶意弹窗与诱导下载。我们定期巡检链接有效性，确保每一次点击都能到达目标页面，让你安心探索视频世界。',
    },
  ];

  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 mb-3 whitespace-nowrap">
              为什么选择我们
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              平台特色
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
              用心甄选，让每一次观影都值得期待
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {features.map((feat, i) => (
              <div
                key={i}
                className="group bg-background-100 rounded-xl p-6 md:p-8 text-center hover:bg-background-200/70 transition-colors duration-300"
              >
                <div className="inline-flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-primary-100 text-primary-500 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                  <i className={`${feat.icon} text-2xl`}></i>
                </div>
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-3 font-heading">
                  {feat.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {feat.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}